import React, { Component } from "react";

import moment from "moment";
import { getpath } from "../actions/get-path";
import { datapop } from "../actions/data-populate";
import { getAction } from "../actions/get-action";
import { bindActionCreators } from "redux";
import { hashHistory } from "react-router";
import {
  createservice,
  getservice,
  updateservice,
  grabservice,
  deleteservice
} from "../services/crudservice";
import { connect } from "react-redux";
import Estimator from "../components/estimates/estimator";
import EstimatorSimple from "../components/estimates/estimatorsimple";
import { newfeedback } from "../actions/feedback";
class ManageEstimate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      estimate: null,
      editmode: false,
      tminvparams: null
    };
  }

  // handleManageEstimate(est){
  //   estimate = {est}
  // }
  componentDidMount() {
    this.props.getpath("Manage Estimate", "calculator");
    this.props.datapop("jtadmin", "AccessRequest");
    if(!this.state.estimate){
      this.getData()
    }
    
  }
  async getData() {
    var rates = await grabservice("salarycodes")
      .then(codes =>
        codes.map(code => {
          return {
            key: code.code,
            text:
              code.description +
              " " +
              "(" +
              code.location +
              ")" +
              "$" +
              code.payrate,
            value: code
          };
        })
      );
    var estimate = await getservice("estimates", this.props.params.estid);
    var tminvparams = await getservice("tminvparams", estimate.custnumber);
    console.log("getting data", tminvparams)
    try {
      this.setState({ tminvparams, estimate, rates })
    } catch (error) {
      console.log(error)
    }
    
  }

  ApproveEstimate() {
    let estimate_status = this.state.estimate.workOrderNbr ? true : false
    let estimate_wod_number = estimate_status ? this.state.estimate.workOrderNbr : this.state.tminvparams.nextwonumber

    if (estimate_status && this.props.wods.findIndex(
      wod => wod.workOrderNbr === estimate_wod_number
    ) > -1) {
      //if estimate has a workorder number and the workorder exists.
      updateservice(
        "estimates",
        {
          ...this.state.estimate,
          edfapprover: this.props.myinfo.empnumber,
          status: "Approved",
          approveddate: moment().format("YYYY-MM-DD"),
          workOrderNbr: estimate_wod_number
        },
        this.state.estimate.id
      ).then(res => {
        this.setState({ estimate: res });
        let wod = {
          ...this.state.estimate,
          contactName: this.state.estimate.projmanager,
          poNbr: this.state.estimate.poNumber,
          budget: this.state.estimate.total
        };
        updateservice("workorders", wod, estimate_wod_number)
          .then(() => {
            window.location.reload();
          })
          .catch(err => console.log(err.message));

      });
    } else {
      // if workorder is new and doesn't have a workorder number
      updateservice(
        "estimates",
        {
          ...this.state.estimate,
          edfapprover: this.props.myinfo.empnumber,
          status: "Approved",
          approveddate: moment().format("YYYY-MM-DD"),
          workOrderNbr: estimate_wod_number
        },
        this.state.estimate.id
      ).then(res => {
        this.setState({ estimate: res });
        console.log("Local Estimate number is", this.state.estimate.workOrderNbr, 'Response Workorder is', res.workOrderNbr)
        let wod = {
          ...this.state.estimate,
          workOrderNbr: estimate_wod_number,
          contactName: this.state.estimate.projmanager,
          status: "NA",
          poNbr: this.state.estimate.poNumber,
          budget: this.state.estimate.total
        };

        if (
          this.props.wods.findIndex(
            wod => wod.workOrderNbr === res.workOrderNbr
          ) === -1
        ) {
          // if workorder does not exist

          console.log("EstWod", wod);
          createservice("workorders", wod)
            .then(() => {
              window.location.reload();
            })
            .catch(err => console.log(err.message));
        } else {
          //workorder exists
          updateservice("workorders", wod, estimate_wod_number)
            .then(() => {
              window.location.reload();
            })
            .catch(err => console.log(err.message));
        }
      });
    }

  }
  handleChange(value, key) {
    this.setState({ estimate: { ...this.state.estimate, [key]: value } }, () =>
      this.estimator.setState({ estimate: this.state.estimate })
    );
  }
  renderestimate() {
    if (this.state.estimate && this.props.myinfo) {
      let employee = this.props.employees.find(
        emp => emp.empnumber === parseInt(this.state.estimate.creator)
      );
      var estimate = this.state.estimate;
      if (this.props.employees && estimate.edfapprover) {
        let employee = this.props.employees.find(
          emp => emp.empnumber === estimate.edfapprover
        );
        estimate = {
          ...estimate,
          billing: this.props.billing.find(b => b.id === estimate.billingNbr),
          edfapprover: employee.firstname + " " + employee.lastname
        };
      }
      var existing_estimate = this.state.estimate.workOrderNbr && this.props.wods.findIndex(
        wod => wod.workOrderNbr === this.state.estimate.workOrderNbr
      ) > -1 ? true : false

      if (this.state.estimate.tasks) {
        //Regular Estimate
        // console.log("existing estimate", existing_estimate);
        // return(<h3>This test worked {this.state.estimate.id}</h3>)
        return (
          <Estimator
            existing_estimate={existing_estimate}
            employee={employee}
            editmode={this.state.editmode}
            approval={!this.state.editmode}
            rates={this.state.rates}
            delete_estimate={() => deleteservice('estimates', estimate.id).then(() => hashHistory.push("/"))}
            billing={this.props.billing.find(b => b.id === estimate.billingNbr)}
            handlesave={estimate =>
              updateservice(
                "estimates",
                { ...estimate, edfapprover: 0 },
                estimate.id
              ).then(response =>
                this.setState({ estimate: response, editmode: false })
              )
            }
            changeModes={() =>
              this.setState({ editmode: !this.state.editmode })
            }
            handleapprove={() => this.ApproveEstimate()}
            estimate={estimate}
            myinfo={this.props.myinfo}
            tminvparams={this.state.tminvparams}
          />
        );
      } else {
        return (
          <EstimatorSimple
            existing_estimate={existing_estimate}
            employee={employee}
            billing={this.props.billing.find(b => b.id === estimate.billingNbr)}
            editmode={this.state.editmode}
            delete_estimate={() => deleteservice('estimates', estimate.id).then(() => hashHistory.push("/"))}
            approval={!this.state.editmode}
            changeModes={() =>
              this.setState({ editmode: !this.state.editmode })
            }
            handlesave={estimate =>
              updateservice(
                "estimates",
                { ...estimate, edfapprover: 0 },
                estimate.id
              ).then(response =>
                this.setState({ estimate: response, editmode: false })
              )
            }
            handleapprove={() => this.ApproveEstimate()}
            estimate={estimate}
            myinfo={this.props.myinfo}
            tminvparams={this.state.tminvparams}
          />
        );
      }
    }
  }
  render() {
    let disclaimerfixed =
      "This is a fixed price task estimate. The task will be charged in full the amount stated on the estimate total. This quote is valid till" +
      moment()
        .endOf("year")
        .format("MM/DD/YYYY");
    return <div>{this.renderestimate()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    billing: state.custinfo.billing,
    myinfo: state.myinfo.employeeinfo,
    pminfo: state.custinfo.engassigned,
    employees: state.employees.employees,
    wods: state.workorders.derivitives
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      newfeedback: newfeedback,
      datapop: datapop,
      getpath: getpath,
      get: getAction
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(ManageEstimate);



// WEBPACK FOOTER //
// ./src/containers/ManageEstimate.js